import React from 'react'
import './loadingSection.css'

const LoadingSection = () => {
  return (
    <div class="rowS">
      <div class="containerS">
          <div class="cardsS">
            <div class="card_imageS loadingS"></div>
            <div class="card_titleS loadingS"></div>
            <div class="card_descriptionS loadingS"></div>
          </div>
          </div>
          </div>
  )
}

export default LoadingSection
